import { useSuspenseQuery } from "@tanstack/react-query";
import {
	createFileRoute,
	useNavigate,
	useParams,
	useSearch,
} from "@tanstack/react-router";
import { Button } from "@/components/base/buttons/button";
import { useAppTranslation } from "@/hooks/use-app-translation";
import { organizationQueryOptions } from "@/services/organization";
import { SearchSchema } from "../$subConId";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/sub-contractors/(sub-con)/$subConId/",
)({
	component: IndexComponent,
	validateSearch: (search) => {
		return SearchSchema.parse(search);
	},
});

function IndexComponent() {
	const { t } = useAppTranslation();
	const navigate = useNavigate();
	const params = useParams({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/sub-contractors/(sub-con)/$subConId/",
	});
	const search = useSearch({
		from: "/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/sub-contractors/(sub-con)/$subConId/",
	});

	const subContractorById = useSuspenseQuery(
		organizationQueryOptions.subContractors.list(params.orgId),
	);

	// const editForm = useEditUserForm(params.userId);

	const isViewMode = search.mode === "view";

	return (
		<div className="space-y-6">
			<div className="flex items-center justify-between">
				<div>
					<h3 className="text-lg font-semibold text-gray-900">
						{t("admin.users.tabs.organization.details.title")}
					</h3>
					<p className="text-sm text-gray-600">
						{t("admin.users.tabs.organization.details.description")}
					</p>
				</div>
				{isViewMode && (
					<Button
						color="primary"
						onClick={() => {
							navigate({
								to: "/org-admin/$orgId/sub-contractors/$subConId/details",
								params: { orgId: params.orgId, subConId: params.subConId },
								search: { mode: "edit" },
							});
						}}
					>
						{t("admin.users.tabs.organization.details.editDetails")}
					</Button>
				)}
			</div>
			<div className="bg-white rounded-lg border border-gray-200 p-6">
				{subContractorById.isLoading ? (
					<div className="flex items-center justify-center py-8">
						<div className="text-sm text-gray-500">
							{t("common.actions.loading")}
						</div>
					</div>
				) : subContractorById.error ? (
					<div className="flex items-center justify-center py-8">
						<div className="text-sm text-red-500">
							{t("common.actions.errorLoading")}
						</div>
					</div>
				) : (
					// biome-ignore lint/suspicious/noExplicitAny: Form types are complex and require type assertion
					// <EditOrganizationFormLayout form={editForm as any} />
					<div>{t("admin.users.tabs.organization.details.title")}</div>
				)}
			</div>
			{/* Form Actions */}
			{!isViewMode && (
				<div className="flex items-center justify-end gap-3 pt-4 border-t border-gray-200">
					<Button
						onClick={() => {
							navigate({
								to: "/org-admin/$orgId/sub-contractors/$subConId/details",
								params: { orgId: params.orgId, subConId: params.subConId },
								search: { mode: "view" },
							});
						}}
					>
						{t("common.actions.cancel")}
					</Button>
					{/* <editForm.Subscribe
						selector={(state) => [
							state.canSubmit,
							state.isSubmitting,
							state.isPristine,
						]}
					>
						{([canSubmit, isSubmitting]) => (
							<Button
								color="primary"
								disabled={!canSubmit || isSubmitting}
								onClick={() => {
									if (canSubmit) {
										editForm.handleSubmit()
									}
								}}
							>
								{isSubmitting ? "Saving..." : "Save Changes"}
							</Button>
						)}
					</editForm.Subscribe>
					*/}
				</div>
			)}
		</div>
	);
}
